const translations = {
    placeholder: 'Service'
};

export default translations;
